import axios from 'axios'

const getActive = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/educational-video/active`)
  return data
}

export {
  getActive
}
